import termsAndConditionsTemplateEn from '@/i18n/termsAndConditions/en'
import acknowledgeTemplateEn from '@/i18n/acknowledgeRisk/en'

export default {
  messages: {
    per_total_income: 'per total income',
    please_specify: 'Please specify',
    loading: 'Loading',
    close: 'Close',
    back: 'Back',
    receive: 'Receive',
    for_receive: 'For receive',
    copied: 'Copied !',
    can_not_copy: `Can't copy, please try again`,
    no_result_found: 'No results found',
    img_size_must_less_than: 'Image size must less than {0} MB',
    uploading_your: 'Uploading your',
    submitting_your_info: 'Submitting your information',
    click_to_see_doc: 'Click to see document',
    congratulations: 'Congratulations',
    you_have_got_kul: `You've got {0} KUL`,
    thanks_for_connect_social_with_us: 'Thank you for connected {0} with us',
    thanks_for_subscribe: 'Thank you for connected subscribe to newsletters with us',
    thanks_for_registration: 'Thank you for your registration',
    thanks_for_submited: 'Thank you for the identification documents.',
    google: 'Google',
    facebook: 'Facebook',
    not_support: 'Not support',
    wrong_eth_network: '<span>Please switch your wallet network to <b>{0} Ethereum Network</b>.</span>',
    please_fill_info: 'Please fill information',
    hi: 'Hi',
    please_confirm_email_after_regis: 'Please confirm your email after completed registration',
    resend_an_email: 'Resend an email',
    metamask_connected: 'Metamask Connected !',
    wallet_connect_connected: 'WalletConnect Connected !',
    login_error: 'Login Error',
    not_login_metamask: 'You are not logged in on <b>MetaMask</b>, Please login and try again.'
  },
  errors: {
    default: 'Something went wrong.',
    balance_not_enough: 'Your balance is not enough.',
    eth_not_enough_for_network_fee: 'Your ETH balance is not enough for network fee.'
  },
  buttons: {
    ok: 'OK',
    login: 'Login',
    logout: 'Logout',
    submit: 'SUBMIT',
    next: 'NEXT',
    back: 'BACK',
    verify_again: 'VERIFY AGAIN',
    login_register: 'LOGIN / REGISTER'
  },
  menu: {
    profile: 'Profile',
    tradeHistory: 'Trade History',
    kyc: 'Identification',
    suit_test: 'Suitability Test',
    knowledge_test: 'Knowledge Test',
    knowledge_test_correct_answer: 'Correct Answer',
    referral_program: 'Referral Program',
    kulap_token: 'KULAP Token',
    logout: 'Logout'
  },
  login: {
    remember_me: 'Remember me',
    login_uppercase: 'LOGIN',
    register_now: 'Register Now'
  },
  register: {
    register: 'Register',
    register_uppercase: 'REGISTER',
    login_with: 'Login with {0}',
    or: 'OR',
    and: 'and',
    email: 'Email',
    email_placeholder: 'Input email',
    password: 'Password',
    password_condition: '(*At least 8 characters including upper case, lower case and digit)',
    password_placeholder: 'Input password',
    password_meter_0: 'Very weak',
    password_meter_1: 'Weak',
    password_meter_2: 'Normal',
    password_meter_3: 'Strong',
    password_meter_4: 'Very strong',
    confirm_password: 'Confirm password',
    confirm_password_placeholder: 'Input confirm password',
    subscribe: 'Subscribe to newsletters',
    agree_to: 'Agree to',
    terms_conditions: 'terms and conditions',
    infor_before_regis: 'term of use',
    privacy_policy: 'Privacy Policy',
    aml_policy: 'AML Policy',
    if_you_have_question: 'If you have questions or encounter any problems.',
    please_contact: 'Please contact email: support@kulap.io (available 24/7).',
    license_by: 'License by'
  },
  register_status: {
    title: 'Registration Success',
    you_have_got_email: 'You have got email.',
    please_confirm_email: 'Please check your email and confirm your email address, to activate your account.',
    if_not_receive_email_facebook: `if you haven't receive confirmation email, please check your junk mail folder or logout and login again.`,
    if_not_receive_email: `if you haven't receive confirmation email, please click link below.`,
    resend_email: 'Resend email'
  },
  confirm_email: {
    verifying: 'Verifying',
    activated: 'Activated',
    welcome: 'Welcome to KULAP',
    activate_detail: 'Your account has been successfully registered. Click the button below to enjoy KULAP exchange.',
    go_to_exchange: 'Go to Exchange',
    error: 'ERROR',
    error_title: 'Something went wrong :(',
    error_detail: 'Click the button below to <b>resend</b> confirmation email or click button <b>Go to Exchange</b> to back to Exchange page.',
    resend_email: 'Resend Email',
    login_first: 'Please login first.',
    click_btn_below: 'Click the button below to <b>Login</b>.'
  },
  notification: {
    nothing_here: 'Ouch... Nothing here.',
    have_no_noti: `You don't have any transactions.`,
    success: 'Success',
    failed: 'Failed',
    on_process: 'On process',
    received_registration_reward: 'Registration complete',
    received_connect_with_facebook_reward: 'Connect with Facebook complete',
    received_connect_with_google_reward: 'Connect with Google complete',
    received_subscribe_news_letter_reward: 'Subscribed KULAP newsletters',
    received_kycapproved_reward: 'Your identification has been verified',
    get_connect_with_facebook_reward: 'Get FREE 50 KUL',
    get_connect_with_google_reward: 'Get FREE 50 KUL',
    get_subscribe_news_letter_reward: 'Get FREE 50 KUL',
    sub_received_kycapproved_reward: 'Get FREE 500 KUL',
    received_referral_program_reward: 'You got rewards from referral program',
    get_referral_program_reward: 'Invite your friends to get rewards',
    take_the_suitability_test: 'Please take the Suitability Test',
    take_the_knowledge_test: 'Please take the Knowledge Test',
    sub_received_registration_reward: 'Received 50 KUL',
    sub_received_connect_with_facebook_reward: 'Received 50 KUL',
    sub_received_connect_with_google_reward: 'Received 50 KUL',
    sub_received_subscribe_news_letter_reward: 'Received 50 KUL',
    sub_received_k_y_c_approved_reward: 'Received 500 KUL',
    sub_get_connect_with_facebook_reward: 'Connect your Facebook account to get reward',
    sub_get_connect_with_google_reward: 'Connect your Google account to get reward',
    sub_get_subscribe_news_letter_reward: 'Subscribe KULAP newsletters to get reward',
    sub_get_k_y_c_approved_reward: 'Submit identification documents to get reward',
    sub_received_referral_program_reward: 'Click to see more detail...',
    sub_get_referral_program_reward: 'Click to see more detail...',
    sub_take_the_suitability_test: 'Start trading once you completed the test.',
    sub_take_the_knowledge_test: 'Start trading once you completed the test.'
  },
  profile: {
    profile: 'Profile',
    display_name: 'Display Name',
    email_address: 'Email Address',
    kul_balance: 'KULAP Token Balance',
    connect_with_facebook: 'Connect with Facebook',
    connect_facebook_acc: 'Connect system with facebook account',
    connect_with_google: 'Connect with Google',
    connect_google_acc: 'Connect system with google account',
    kyc_detail: 'User must fill the identity verification form and upload supplementary documents',
    exchange_condition: 'Start trading once you completed the verification',
    suitability_test_condition: 'Start trading once you completed the test',
    knowledge_test_condition: 'Start trading once you completed the test',
    unverified: 'Verification',
    verifying: 'Pending',
    request_change: 'Incorrect Information',
    approved: 'Verified',
    rejected: 'Rejected',
    suit_test_detail: 'Questionnaire to assess the suitability of customer investment',
    take_a_test: 'Take a test',
    knowledge_test_detail: 'Questionnaire to assess knowledge about customer investment',
    subscribe: 'Subscribe to newsletters',
    subscribe_detail: 'Subscribe to receive the latest updates from KULAP',
    two_fact: 'Two-Factor Authentication',
    two_fact_detail: 'Stronger security for your account with 2-step verification'
  },
  kyc: {
    nationality: 'Nationality',
    information: 'Information',
    address: 'Address',
    identification: 'Identification',
    summary: 'Summary',
    customer_nationality: 'Customer nationality',
    maintenance_header: 'KYC System Maintenance',
    maintenance_info: 'Our KYC system is currently undergoing maintenance. Please check back later.',
    verify_kulap_plus_title: 'Verify Your Identity on Kulap Plus',
    verify_kulap_plus_detail: 'As a new user, please verify your identity on our Kulap Plus platform using the same email address. This process helps ensure your account is secure and ready for use.',
    verify_kulap_plus_link_text: 'Start Verification',
    customer_type: 'Customer type',
    select_customer_type: 'Select a customer type',
    personal: 'Personal',
    organization: 'Organization',
    customer_information: 'Customer information',
    name_title: 'Name title',
    mr: 'Mr.',
    miss: 'Miss.',
    mrs: 'Mrs.',
    last_name_th: 'Last name (THAI)',
    first_name_th: 'First name (THAI)',
    first_name: 'First name (ENG)',
    middle_name: 'Middle Name (optional)',
    middle_name_summary: 'Middle name',
    last_name: 'Last name (ENG)',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    marital_status: 'Marital status',
    single: 'Single',
    married: 'Married',
    date_of_birth: 'Date of birth',
    tel_number: 'Mobile phone number',
    click_to_select: 'Click to select...',
    tel_placeholder: 'For example 0817766554',
    your_company: 'Your company name',
    your_company_address: 'Company address',
    your_company_address_line_2: 'Company address line 2 (optional)',
    your_company_address_line_2_summary: 'Company address line 2',
    your_company_country: 'Country of company',
    your_company_province: 'Province / State of company',
    your_company_city: 'City of company',
    your_company_zipcode: 'Zipcode / Postcode of company',
    your_company_summary: 'Your company name',
    company_placholder: 'For example Satoshi Co., Ltd.',
    occupation: 'Occupation',
    occupation_specify_detail: 'Please specify',
    occupation_specify_detail_placeholder: 'please specify',
    avg_income: 'Average monthly income',
    proof_of_income: 'Proof of income',
    ex_proof_of_income_for_personal: 'ex. Bank statements, pay slip, Evidence of social security contributions etc.',
    ex_proof_of_income_for_org: 'ex. Bank statements etc.',
    doc_limit: 'Document size must less than',
    evidence_assets: 'Evidence of asset ownership',
    ex_evidence_assets: 'ex. Bank statements, GSB lottery, Title deed, Car registration book etc.',
    customer_address: 'Customer address',
    origin_address: 'Origin address',
    address_placeholder: 'Input your address',
    address_line_2: 'Origin Address Line 2 (optional)',
    address_line_2_summary: 'Origin Address line 2',
    country: 'Country',
    province: 'Province / State',
    province_placeholder: 'Input your province / State',
    city_placeholder: 'Input your city',
    city: 'City',
    zipcode: 'Zipcode / Postcode',
    current_addr_same_origin: 'Current address same as origin address',
    current_address: 'Current address',
    customer_identification: 'Customer identification',
    type_of_card: 'Type of card',
    id_card: 'ID Card',
    passport: 'Passport',
    id_card_passport: 'ID Card / Passport',
    id_card_placeholder: 'Input your number',
    laser_code: 'Laser code',
    laser_code_placeholder: 'For example JT9999999999',
    ex_laser_code: 'Example laser code',
    date_of_issue: 'Date of issue',
    date_of_exp: 'Date of expiry',
    photo_id_card: 'Photo ID Card / Passport',
    photo_selfie: 'Photo selfie with document',
    gov_issued: 'Government issued document',
    life_time_id_card: 'Lifetime ID Card',
    upload_id_card: 'Upload photo of your {typeOfCard} (please take a picture from the original documents only)',
    upload_gov_issued: 'Upload a Government issued document that confirms your identity, such as a driver\'s license',
    max_file_type: 'Maximum file size of {0} MB and supports file  jpg , jpeg , png',
    upload_selfie: 'Please take a selfie with your document so that it’s clearly visible and does not cover your face. (please take a picture with the original document only)',
    browse: 'Browse your photo',
    browse_file: 'Browse file',
    ex_id_card: 'Example: {typeOfCard}.',
    ex_selfie: 'Example: selfie photo with your document.',
    terms: 'Terms and Conditions',
    info_disclosure: 'Customers must reading the terms and conditions first, So can click to accept the terms and conditions disclosure agreement.',
    i_agree_terms: 'I agree Terms and Conditions',
    cert_not_over_six_months: 'Certified by the department of business development, not over 6 months',
    if_any: 'if any',
    comp_cert_doc: 'Company certificate document',
    list_shareholders_doc: 'Copy of list of shareholders document',
    seal_cert_doc: 'Copy of Seal certificate document',
    copy_house_registration: 'Copy of house registration of authorized director',
    power_attorney: 'Power of attorney',
    power_attorney_lowercase: 'power of attorney',
    send_info_success: 'Send information successfully',
    thanks_for_submited: 'Thank you for submitted identification documents. Please wait for our following confirmation email. (please re-check your spam or junk folder)',
    kyc_status: 'Identification status',
    org_info: 'Organization Information',
    tax_id: 'Entity Number / Tax ID',
    business_type: 'Business type',
    auth_represent: 'Authorized representative',
    auth_represent_subtitle: 'If there is no authorization Fill out the information of the authorized director for the transaction. But if the power is given Fill out the information of the attorney.',
    auth_represent_info: 'Authorized representative information',
    auth_represent_addr: 'Authorized representative address',
    auth_represent_identity: 'Authorized representative identity',
    company_name: 'Company name (optional)',
    company_address: 'Company address',
    company_address_line_2: 'Company address line 2 (optional)',
    company_country: 'Country',
    company_province: 'Province / State',
    company_city: 'City',
    company_zipcode: 'Zipcode / Postcode',
    company_tel_number: 'Phone number',
    company_tel_placeholder: 'For example 0817766554',
    unverified: 'Unverified',
    request_change: 'Incorrect information',
    request_change_title: 'Please correct the information below',
    request_change_detail: 'Some informations are incorrect, or request to change. If you need any help please contact support@kulap.io.',
    request_change_kulap_plus_title: 'Please update your KYC',
    request_change_kulap_plus_detail: 'Please update your KYC information on our new Kulap Plus platform to continue using our services. Click the link below to update your information.',
    request_change_kulap_plus_link_text: 'Update KYC on Kulap Plus',
    request_change_kulap_plus_footer: 'If you need any help, please contact support@kulap.io.',
    verifying: 'Pending',
    verifying_title: 'Information has been submitted successfully',
    verifying_detail: 'Thank you for submitting your identification documents. When the documents have been verifed, the result will be sent to your email as soon as possible. (please re-check your spam or junk folder)',
    rejected: 'Rejected',
    rejected_title: 'Your identification is rejected.',
    rejected_detail: 'Your identification is rejected.',
    rejected_detail_2: 'With deepest apologies,',
    rejected_detail_3: 'If you need more information please contact <a>support@kulap.io</a>',
    rejected_detail_4: 'KULAP Team Supports',
    approved: 'Verified',
    approved_title: 'Verification complete',
    approved_detail: 'We have successfully reviewed your information.',
    detail_selfie: {
      l1: 'Please take a selfie with your document so that it’s clearly visible and does not cover your face.',
      l2: 'Take a photo with your <b>{typeOfCard}.</b>',
      l3: 'Written on paper in handwriting indicating your <b>Name and Last Name.</b>',
      l4: 'Written on paper in handwriting indicating the <b>day-month-year</b> of today.',
      l5: 'Written in the paper <b>"KULAP"</b>'
    },
    facta_title: 'FATCA',
    facta_sub_title: 'In compliance with the Foreign Account Tax Compliance Act (FATCA), Satoshi company limited is required to obtain the following self-certification from you. (For more information, please go to <a href="https://www.irs.gov" target="_blank">www.irs.gov</a>)',
    is_american: 'Are you a U.S. citizen?',
    is_american_for_pay_tax: 'Are you a U.S. resident for tax purposes?',
    say_yes: 'Yes',
    say_no: 'No',
    american_tax_id: 'U.S. Taxpayer Identification Number (TIN)',
    american_tax_id_placeholder: 'Input your tax number'
  },
  forgot_password: {
    forgot_password: 'Forgot Password?',
    sent: 'Sent!',
    please_check_your_email_and_confirm: 'Please check your email and confirm your email address, to activate your account.',
    if_you_do_not_receive: `If you don't receive an email from us within a few minutes. check you spam filter as sometimes the end up in there.`,
    email_will_from: 'The email will be from',
    enter_your_email: `Enter your email address and we'll send you an email with instructions to reset your password.`,
    email: 'Email Address',
    email_placeholder: 'For example abc@gmail.com'
  },
  reset_password: {
    reset_password: 'Reset Password'
  },
  send_confirm_email: {
    send_confirm_email: 'Send Confirmation Email',
    send_confirm_email_detail: 'Please click button below to send confirmation email to <b>{0}</b> and check you email inbox to activate your account.'
  },
  exchange: {
    metamask: 'Metamask',
    metamask_detail: 'Brings Ethereum to your computer.',
    connect: 'Connect',
    disconnect: 'Disconnect',
    coming_soon: 'Coming soon',
    install_metamask: 'Install Metamask',
    trezor: 'Trezor',
    trezor_detail: 'The secure hardware crypto wallets.',
    ledger: 'Ledger',
    ledger_detail: 'The secure hardware crypto wallets.',
    mobile_detail: 'Secure connect your Mobile Wallet with Wallet Connect Technology.',
    wallet_connect: 'WalletConnect',
    from_token: 'FROM TOKEN',
    max_balance: 'Max Balance',
    to_token: 'TO TOKEN',
    estimate_rate: 'Estimated Rate',
    advanced_setting: 'Advanced Setting',
    max_rate_change: 'Maximum price slippage',
    max_slippage_detail: 'Transaction will revert if the price changes unfavorably by more than this percentage.',
    network_fee: 'Network fee',
    network_fee_detail: 'A cost for running a transaction on blockchain.',
    platform_fee: 'Platform fee',
    platform_fee_detail: 'KULAP platform trading fee',
    estimate_time: 'Estimated time',
    minutes: 'Minutes',
    slow: 'Slow',
    standard: 'Standard',
    fast: 'Fast',
    exchange_token: 'EXCHANGE TOKEN',
    estimate_balance: 'ESTIMATED BALANCE',
    connected: 'Connected',
    metamask_help: 'Metamask Help?',
    cipher_help: 'Cipher Help?',
    coin_base_wallet_help: 'Coinbase Wallet Help?',
    trust_help: 'Trust Help?',
    wallet_connect_help: 'WalletConnect Help?',
    address_lowercase: 'adresss',
    address_uppercase: 'ADDRESS',
    token_balance: 'Token Balance',
    see_more: 'See more',
    see_less: 'See less',
    token_name: 'Token name',
    change_24_hr: 'Change 24 hour',
    price_usd: 'Price USD',
    buy_sell_token: 'Buy / Sell Token',
    buy: 'BUY',
    sell: 'SELL',
    confirm_exchange: 'CONFIRM EXCHANGE',
    gas_price_notice: 'Gas price notice',
    gas_price_notice_detail: 'Changing gas price value will result in a failed transaction.',
    confirm: 'CONFIRM',
    allow_exchange: 'Exchange Allowance',
    allow_exchange_detail: 'Please allow us to exchange your {0} asset.',
    your_address_is: 'Your address is',
    approve: 'APPROVE',
    on_process: 'ON PROCESS',
    tx_is_pending_text: 'Transaction is pending confirmed on blockchain.',
    you_can_view_tx: 'You can view transaction details',
    failed: 'FAILED',
    failed_detail: 'Failed to exchanged',
    rate: 'Rate',
    complete: 'COMPLETE',
    complete_detail: 'You successfully exchanged.',
    token_can_not_be_exchanged: 'The token cannot be exchanged',
    token_can_not_be_exchanged_detail: 'You must confirm your identity under the following conditions',
    kyc_detail: 'User must filled the identity verification form and upload the additional documents',
    suit_test_detail: 'Questionnaire to assess the suitability of customer investment',
    knowledge_test_detail: 'Questionnaire to assess knowledge about customer investment',
    confirm_email: 'Confirm Email',
    confirm_email_detail: 'Please confirm your email after completed registration',
    select_token: 'SELECT TOKEN',
    select_token_placeholder: 'Search token name',
    invalid_price_slippage_value: 'The Price Slippage must be between 0% and 10%.'
  },
  suit_test: {
    country: 'country no.{index}',
    q_1: {
      q: 'What is your age?',
      a_1: '20 years old or below.',
      a_2: 'From 20 years old but not over 30 years old.',
      a_3: 'From 30 years old but not over 45 years old.',
      a_4: 'From 45 years old but not over 60 years old.',
      a_5: '60 years old or above.'
    },
    q_2: {
      q: 'Level of education',
      a_1: `Under bachelor’s degree.`,
      a_2: `Bachelor's degree.`,
      a_3: 'Master’s degree or above.'
    },
    q_3: {
      q: 'Purpose of using services (Can choose more than 1 item)',
      a_1: 'Savings',
      a_2: 'Investment',
      a_3: 'Transferring international digital assets',
      a_4: 'Purchasing ICO Tokens',
      a_5: 'Others'
    },
    q_4: {
      q: 'Investment period (The expected investment period in digital assets)',
      a_1: 'Not over 1 month.',
      a_2: 'More than 1 month but not over 6 months.',
      a_3: 'Over 6 months but not over 1 year.',
      a_4: 'More than 1 year but not over 3 years.',
      a_5: '3 years and above.'
    },
    q_5: {
      q: 'Source of income (Can choose more than 1 item)',
      a_1: `Savings`,
      a_2: 'Salary / wage',
      a_3: 'Inheritance / gift',
      a_4: 'Personal business',
      a_5: 'Instruments / funds',
      a_6: 'Parent',
      a_7: 'Others'
    },
    q_6: {
      q: 'What countries do you have your income from?',
      a_1: `Source of income from a single country`,
      a_2: 'Source of income is 80% or more from Thailand, the rest is from another country',
      a_3: 'Source of income is less than 80% from Thailand, the rest is from another country',
      a_4: 'Source of income is from 2 countries and not from Thailand',
      a_5: 'Source of income is from more than 2 countries and not from Thailand'
    },
    q_7: {
      q: 'Average monthly income',
      a_1: `Less than 10,000 baht (less than 300 USD)`,
      a_2: '10,000 - 14,999 baht (300 USD - 449 USD)',
      a_3: '15,000 - 34,999 baht (450 USD - 999 USD)',
      a_4: '35,000 - 49,999 baht (1,000 USD - 1,499 USD)',
      a_5: '50,000 - 99,999 baht (1,500 USD - 2,999 USD)',
      a_6: '100,000 - 499,999 baht (3,000 USD - 14,999 USD)',
      a_7: 'More than 500,000 baht (more than 15,000 USD)'
    },
    q_8: {
      q: 'Total amount of assets owned',
      a_1: `Less than 500,000 baht (less than 15,000 USD)`,
      a_2: '500,000 - 1,000,000 baht (15,000 USD - 29,999 USD)',
      a_3: '1,000,000 - 5,000,000 baht (30,000 USD - 149,999 USD)',
      a_4: '5,000,000 - 10,000,000 baht (150,000 USD - 299,999 USD)',
      a_5: '10,000,000 - 100,000,000 baht (300,000 USD - 2,999,999 USD)',
      a_6: 'More than 100,000,000 baht (more than 3,000,000 USD)'
    },
    q_9: {
      q: 'Proportion of investment between digital assets and all assets',
      a_1: `Less than 10 percent.`,
      a_2: 'From 10 percent but not over 30 percent.',
      a_3: 'From 30 percent but not over 50 percent.',
      a_4: 'From 50 percent but not over 80 percent.',
      a_5: 'More than 80 percent.'
    },
    q_10: {
      q: 'Do you have any investing experience in securities? (securities mean investment units, shares, debentures, government bonds, derivatives digital assets or other similar financial instruments)',
      a_1: `None`,
      a_2: '1 year',
      a_3: 'From 1 year but not over 3 years.',
      a_4: 'From 3 years but not over 10 years.',
      a_5: 'More than 10 years.'
    },
    q_11: {
      q: 'Acceptable level of investment risk',
      a_1: `Cannot accept any risk, prefer a secure investment, Generate regular income despite low returns.`,
      a_2: 'Can accept moderate risk for receiving the opportunity to gain higher returns in higher long-term returns.',
      a_3: 'Can accept high risk for receiving the opportunity to gain higher returns in higher long-term returns.',
      a_4: 'Can accept any risk at the highest level for receiving the opportunity to gain the highest returns in the investment.'
    },
    q_12: {
      q: 'How much do you think you can accept the loss of your investment?',
      a_1: `Unacceptable for any loss.`,
      a_2: 'Less than 10 percent of the investment.',
      a_3: 'Approximately 10 - 30 percent of the investment.',
      a_4: 'Approximately 30 - 70 percent of the investment.',
      a_5: 'Acceptable for all losses.'
    },
    q_13: {
      q: 'Have you been judged guilty of offenses relating to the property or the court ordered that the property belongs to the state?',
      a_1: `No, I haven’t.`,
      a_2: 'Yes, I have'
    },
    q_14: {
      q: 'Have you been requested to declare the list of your assets to government agencies such as Office of the National Anti-Corruption Commission, Anti-Money Laundering Office?',
      a_1: `No, I haven’t.`,
      a_2: 'Yes, I have'
    },
    alert_message: '*Please read message or scroll through message to the end of the line.',
    accept_acknowledge_risk: 'The Customer read and understand all the risks associated with the digital assets trading transactions.'
  },
  knowledge_test: {
    blockchain_basic: {
      q_1: {
        q: 'Before the blockchain technology took place, what were the disadvantages of electronic data?',
        a_1: 'The data is easily imitated.',
        a_2: 'Data cannot be edited.',
        a_3: 'Data transfer slowly.'
      },
      q_2: {
        q: 'What type of digital asset is the blockchain technology first introduced?',
        a_1: 'Litecoin',
        a_2: 'Bitcoin',
        a_3: 'XRP'
      },
      q_3: {
        q: 'How many bitcoins are there?',
        a_1: '21 million bitcoins',
        a_2: '1 million bitcoins',
        a_3: 'Unlimited amount'
      },
      q_4: {
        q: 'What will happen when there are 21 million bitcoins?',
        a_1: 'It will continue to be produced at a constant rate.',
        a_2: 'No new bitcoins will be produced.',
        a_3: 'Bitcoin will be destroyed every 30 minutes.'
      },
      q_5: {
        q: 'Which technologies are listed in the Bitcoin prospectus?',
        a_1: 'Blockchain technology',
        a_2: 'Cryptography',
        a_3: 'All of the above'
      },
      q_6: {
        q: 'What is the purpose of creating Bitcoin?',
        a_1: 'Establish a financial system supported by the government.',
        a_2: 'Create an electronic financial system without intermediaries.',
        a_3: 'Launch an international money transfer system.'
      },
      q_7: {
        q: 'Which is a unique feature of Bitcoin?',
        a_1: 'Increase the efficiency of commercial banks.',
        a_2: 'Transactions do not need a middleman.',
        a_3: 'Transferring digital assets is faster than other digital assets.'
      },
      q_8: {
        q: 'What is the decimal point in the smallest unit of bitcoins?',
        a_1: 'Bitcoin does not have any units or decimal digits.',
        a_2: 'Two digits',
        a_3: 'Eight digits'
      },
      q_9: {
        q: 'What is the smallest unit of Bitcoin?',
        a_1: 'Satoshi',
        a_2: 'Bitcoin Cash',
        a_3: 'Bitcoin Mini'
      },
      q_10: {
        q: 'What can Bitcoins be used for?',
        a_1: 'Purchase products and services',
        a_2: 'Invest in ICO',
        a_3: 'All of the above'
      },
      q_11: {
        q: 'Who can check the source code of Bitcoin?',
        a_1: 'Bitcoin core developer',
        a_2: 'Everyone can check it',
        a_3: 'SEC (Securities & Exchange Commission)'
      },
      q_12: {
        q: 'Where can the Bitcoin source code be verified?',
        a_1: 'Github',
        a_2: 'ETDA',
        a_3: 'SEC'
      },
      q_13: {
        q: 'What is Satoshi?',
        a_1: 'The smallest unit of Bitcoin.',
        a_2: 'Devices used to store digital assets.',
        a_3: 'Another name of Private Key.'
      },
      q_14: {
        q: 'How much is the value of MBTC?',
        a_1: '1 million Bitcoins',
        a_2: '1 Bitcoin',
        a_3: '0.001 Bitcoin'
      },
      q_15: {
        q: 'Which is not a way to store blockchain data?',
        a_1: 'Block structure design',
        a_2: 'Distributing multiple storage locations',
        a_3: 'Centralized data collection'
      },
      q_16: {
        q: 'What is the kind of problem that Blockchain technology occurred to solve?',
        a_1: 'Forgery',
        a_2: 'Data accuracy',
        a_3: 'Speed of data transfer'
      },
      q_17: {
        q: 'Which one is the benefit of blockchain technology?',
        a_1: 'Users can examine each other\'s information.',
        a_2: 'A centralized authority controls the data.',
        a_3: 'It can prove that the information is accurate and correct.'
      },
      q_18: {
        q: 'Which is the way of blockchain data collection?',
        a_1: 'Chain reference',
        a_2: 'Collecting small data to store large amounts of data',
        a_3: 'All of the above'
      },
      q_19: {
        q: 'How long does Bitcoin take to confirm a transaction?',
        a_1: 'Every second',
        a_2: 'Every 10 minutes',
        a_3: 'Every 1 hour'
      },
      q_20: {
        q: 'What is Block reward?',
        a_1: 'The reward received by the person confirming the transaction from the transaction confirmation.',
        a_2: 'The reward that digital token makers have received from successful fundraising.',
        a_3: 'The reward for the first person who can buy a digital token from fundraising.'
      }
    },
    investment: {
      q_1: {
        q: 'What is the address resemble in the bank account system?',
        a_1: 'Password',
        a_2: 'Account number',
        a_3: 'Transaction code'
      },
      q_2: {
        q: 'How many Addresses can a person have?',
        a_1: 'Only one Address',
        a_2: 'The amount specified by the SEC',
        a_3: 'Unlimited amount'
      },
      q_3: {
        q: 'What is the difference between an address and a bank account?',
        a_1: 'An address does not have personal information.',
        a_2: 'The digital asset trading center controls the address.',
        a_3: 'The address opening must be registered with the SEC.'
      },
      q_4: {
        q: 'What will the transferee of digital assets have to give to the transferor?',
        a_1: 'Private key',
        a_2: 'Address',
        a_3: 'Email'
      },
      q_5: {
        q: 'What are the precautions when transferring digital assets?',
        a_1: 'Check the address of the transferee correctly.',
        a_2: 'Command the transferor not to disclose the transferee\'s private key.',
        a_3: 'Do not send the recipient\'s Address to the transferor.'
      },
      q_6: {
        q: 'What is the most private key similar to?',
        a_1: 'Password',
        a_2: 'Username',
        a_3: 'Email'
      },
      q_7: {
        q: 'What should a digital asset holder keep secret?',
        a_1: 'Address',
        a_2: 'Email',
        a_3: 'Private key'
      },
      q_8: {
        q: 'Which one is not the type of Wallet?',
        a_1: 'Hot wallet',
        a_2: 'Cold storage',
        a_3: 'Safety express'
      },
      q_9: {
        q: 'What kind of Wallet will the users store private keys by themselves?',
        a_1: 'Hot wallet',
        a_2: 'Cold storage',
        a_3: 'All of the above'
      },
      q_10: {
        q: 'What kind of Wallet will the service provider store the private key on behalf of customers?',
        a_1: 'Hot wallet',
        a_2: 'Cold storage',
        a_3: 'Paper wallet'
      },
      q_11: {
        q: 'Which one is the name of the Hardware wallet device?',
        a_1: 'Coinman',
        a_2: 'Cryptoventure',
        a_3: 'Trezor'
      },
      q_12: {
        q: 'Which type of Wallet has the highest price?',
        a_1: 'Hot wallet',
        a_2: 'Paper wallet',
        a_3: 'Hardware wallet'
      },
      q_13: {
        q: 'If A buys Bitcoins worth 30 million baht, where is the safest place should he keep them?',
        a_1: 'Commercial bank',
        a_2: 'Overseas digital asset trading center',
        a_3: 'Hardware wallet'
      },
      q_14: {
        q: 'Which digital asset storage is the least secure?',
        a_1: 'Keep the private key on the computer.',
        a_2: 'Keep the private key in the Paper wallet.',
        a_3: 'Keep the private key in the Hardware wallet.'
      },
      q_15: {
        q: 'Which digital asset storage is the most secure?',
        a_1: 'Keep the private key on the computer.',
        a_2: 'Keep the private key in the Paper wallet.',
        a_3: 'Keep the private key at the non-licensed by the SEC digital asset trading center.'
      },
      q_16: {
        q: 'A keeps digital assets by himself using the Paper wallet method. If A loses the Paper wallet, how can he reset the private key?',
        a_1: 'Notify the SEC',
        a_2: 'Notify the Bank of Thailand',
        a_3: 'Cannot reset the private key'
      },
      q_17: {
        q: 'A collects digital assets by himself using a Hardware wallet (Trezor). If A loses Trezor, how can he reset the private key?',
        a_1: 'Notify the SEC',
        a_2: 'Use reserved seeds',
        a_3: 'Cannot reset the private key'
      },
      q_18: {
        q: 'A uses the digital asset trading service through the digital asset trading center. If A forgets the password, how can A reset the password?',
        a_1: 'Notify the SEC',
        a_2: 'Notify the digital asset trading center',
        a_3: 'Cannot reset the password'
      },
      q_19: {
        q: 'Where can investors check the results of digital asset transfers?',
        a_1: 'Blockexplorer',
        a_2: 'Blockcypher',
        a_3: 'All of the above'
      },
      q_20: {
        q: 'What can investors use to monitor transaction results?',
        a_1: 'Address',
        a_2: 'Transaction ID',
        a_3: 'All of the above'
      }
    },
    legal: {
      q_1: {
        q: 'Which is the agency that oversees digital asset business operators under the Digital Asset Decree?',
        a_1: 'Bank of Thailand',
        a_2: 'SEC',
        a_3: 'Revenue Department'
      },
      q_2: {
        q: 'Where can investors check the list of licensed digital asset business operators?',
        a_1: 'Bank of Thailand',
        a_2: 'SEC',
        a_3: 'Thai Blockchain Association'
      },
      q_3: {
        q: 'What is the legal status of Cryptocurrencies in Thailand?',
        a_1: 'Illegal',
        a_2: 'Electronic information',
        a_3: 'A type of currency'
      },
      q_4: {
        q: 'What is the legal status of Bitcoin in Thailand?',
        a_1: 'An asset',
        a_2: 'A type of currency',
        a_3: 'Not legally certified'
      },
      q_5: {
        q: 'What is the legal status of JFin Coin in Thailand?',
        a_1: 'Digital token',
        a_2: 'A type of currency',
        a_3: 'Not legally certified'
      },
      q_6: {
        q: 'Which of the following digital assets is not a digital asset specified by the SEC as a cryptocurrency that a digital asset business operator can accept?',
        a_1: 'Bitcoin',
        a_2: 'XRP',
        a_3: 'JFin coin'
      },
      q_7: {
        q: 'Which of the following digital assets is not a digital asset specified by the SEC as a cryptocurrency that a digital asset business operator can accept?',
        a_1: 'Ethereum Classic',
        a_2: 'Dev Network',
        a_3: 'Stellar'
      },
      q_8: {
        q: 'What kind of business operator is the center to facilitate those who wish to buy, sell, or exchange digital assets to enter into an agreement or match?',
        a_1: 'Exchange Center',
        a_2: 'Broker',
        a_3: 'Dealer'
      },
      q_9: {
        q: 'What kind of business operator is an agent to buy, sell, or exchange digital assets for others by regular business practice?',
        a_1: 'Exchange Center',
        a_2: 'Broker',
        a_3: 'Dealer'
      },
      q_10: {
        q: 'What kind of business operator shows to the public that they are ready to provide services for buying and selling digital assets in their name regularly?',
        a_1: 'Exchange Center',
        a_2: 'Broker',
        a_3: 'Dealer'
      },
      q_11: {
        q: 'What kind of business operators screen the nature of the digital token offered?',
        a_1: 'Exchange Center',
        a_2: 'ICO Portal',
        a_3: 'Dealer'
      },
      q_12: {
        q: 'What is the advantage of trading digital assets using the services of a digital asset trader?',
        a_1: 'Standard inspected by government agencies.',
        a_2: 'If damage occurs, investors will receive litigation services from government agencies free of charge.',
        a_3: 'All of the above'
      },
      q_13: {
        q: 'Which of the following businesses does not need to be licensed by the SEC?',
        a_1: 'Bitcoin mining business',
        a_2: 'ICO Portal',
        a_3: 'Dealer'
      },
      q_14: {
        q: 'What is a Segregated Account?',
        a_1: 'The business operator must submit customer information to the SEC.',
        a_2: 'The business operator must keep a client\'s asset account separate from their property account.',
        a_3: 'The business operator must check customer accounts regularly.'
      },
      q_15: {
        q: 'In case that customers deposit their digital assets with a digital asset operator, who is the owner of those digital assets?',
        a_1: 'Digital Asset Operator',
        a_2: 'Customer',
        a_3: 'SEC'
      },
      q_16: {
        q: 'What is Insider Trading?',
        a_1: 'Prohibiting company employees from using the digital asset exchange service of their own companies.',
        a_2: 'Prohibiting the employees of the company from the trading personal information of customers.',
        a_3: 'Prohibiting insiders from knowing inside information about digital assets to trade and exchange such digital assets.'
      },
      q_17: {
        q: 'Which of the following actions is not an offense under the Digital Asset Business Operation Decree?',
        a_1: 'Insider Trading',
        a_2: 'Arbitrage Trading',
        a_3: 'Market Manipulation'
      },
      q_18: {
        q: 'Trading or exchanging to distort the price and volume of digital asset trades from its reasonable condition so that the general public is misled about the price or volume, what is the act of trading and hoping to benefit from the distortion called?',
        a_1: 'Insider Trading',
        a_2: 'Arbitrage Trading',
        a_3: 'Market Manipulation'
      },
      q_19: {
        q: 'Which of the following acts is presumed by law to be the culprit in the commission of an offense?',
        a_1: 'Allow others to share bank accounts with them',
        a_2: 'Paying digital assets on behalf of one another',
        a_3: 'All of the above'
      },
      q_20: {
        q: 'Which of the following acts is presumed by law to be the culprit in the commission of an offense?',
        a_1: 'Transfer or receive digital assets transferred between each other',
        a_2: 'Allow other people to use their digital asset trading accounts',
        a_3: 'All of the above'
      }
    },
    service_form: {
      q_1: {
        q: 'Which is the nature of spot trading?',
        a_1: 'Trading of assets at current prices.',
        a_2: 'Borrowing other people\'s assets to increase profitability opportunities.',
        a_3: 'Making a forward contract.'
      },
      q_2: {
        q: 'Which are the characteristics of margin trading?',
        a_1: 'Trading of assets at current prices.',
        a_2: 'Borrowing other people\'s assets to increase profitability opportunities.',
        a_3: 'Making a forward contract'
      },
      q_3: {
        q: 'What kind of digital asset trading center is transferring digital assets via a smart contract?',
        a_1: 'Centralized exchange',
        a_2: 'Decentralized Exchange',
        a_3: 'All of the above'
      },
      q_4: {
        q: 'Which is the form of trading assets at current prices?',
        a_1: 'Spot Trading',
        a_2: 'Margin Trading',
        a_3: 'Future Trading'
      },
      q_5: {
        q: 'Which is a form of borrowing other assets to increase profitability opportunities?',
        a_1: 'Spot Trading',
        a_2: 'Margin Trading',
        a_3: 'Future Trading'
      },
      q_6: {
        q: 'A would like to buy one bitcoin for 200,000 baht per bit. If there is no Bitcoin seller at 200,000 baht per bit, the system will set an order. Which form of trading should A use?',
        a_1: 'Good till cancel',
        a_2: 'Immediately or cancel',
        a_3: 'Fill or kill'
      },
      q_7: {
        q: 'A creates a Bitcoin purchase order of 1 bitcoin for 200,000 baht per bit using the Good till cancel method. If there is no Bitcoin seller at 200,000 baht per bit, what will be the effect?',
        a_1: 'The system will create an order to leave in the system.',
        a_2: 'The system will buy the bitcoins that are available at that price and cancel the remaining orders immediately.',
        a_3: 'The system will not create any orders.'
      },
      q_8: {
        q: 'A creates a Bitcoin purchase order of 1 bitcoin for 200,000 baht per bit using the Instant or cancel method. If there is no Bitcoin seller at the price of 200,000 baht per bit, what will be the effect?',
        a_1: 'The system will create an order to leave in the system.',
        a_2: 'The system will buy the bitcoins that are available at that price and cancel the remaining orders immediately.',
        a_3: 'The system will not create any orders.'
      },
      q_9: {
        q: 'A creates a Bitcoin purchase order of 1 bitcoin at 200,000 baht per bit using the Fill to kill method. If there is no Bitcoin seller at the price of 200,000 baht per bit, what will be the effect?',
        a_1: 'The system will create an order to leave in the system.',
        a_2: 'The system will buy the bitcoins that are available at that price and cancel the remaining orders immediately.',
        a_3: 'The system will not create any orders.'
      },
      q_10: {
        q: 'Which is the nature of trading using Limit order?',
        a_1: 'Trading assets at a price specified by the user.',
        a_2: 'Trading of assets regardless of the asset\'s price at that time.',
        a_3: 'When digital assets increase or decrease to the specified point in order to place a purchase order.'
      },
      q_11: {
        q: 'Which is the nature of trading using Market order?',
        a_1: 'Trading assets at a price specified by the user.',
        a_2: 'Trading of assets regardless of the asset\'s price at that time.',
        a_3: 'When digital assets increase or decrease to the specified point in order to place a purchase order.'
      },
      q_12: {
        q: 'Which is the nature of trading using a Stop order?',
        a_1: 'Trading assets at a price specified by the user.',
        a_2: 'Trading of assets regardless of the asset\'s price at that time.',
        a_3: 'When digital assets increase or decrease to the specified point in order to place a purchase order.'
      },
      q_13: {
        q: 'What type of order is trading assets at a price specified by the user?',
        a_1: 'Limit order',
        a_2: 'Market order',
        a_3: 'Stop order'
      },
      q_14: {
        q: 'What type of order describes a trading of assets regardless of the asset\'s price at that time?',
        a_1: 'Limit order',
        a_2: 'Market order',
        a_3: 'Stop order'
      },
      q_15: {
        q: 'What type of order when digital assets increase or decrease to the specified point in order to place a purchase order?',
        a_1: 'Limit order',
        a_2: 'Market order',
        a_3: 'Stop order'
      },
      q_16: {
        q: 'When investors use the margin trading service of the Digital Asset Trading Center and have a loss to a high level of risk, the system will alert them. What is the mentioned notification called?',
        a_1: 'Margin call',
        a_2: 'Force sell',
        a_3: 'Leverage'
      },
      q_17: {
        q: 'Which is the risk of margin trading?',
        a_1: 'The trader is likely to be stolen digital assets.',
        a_2: 'The trader has a higher chance of losing when price fluctuations occur.',
        a_3: 'All of the above'
      },
      q_18: {
        q: 'Which are the trading forms that inexperienced investors should avoid?',
        a_1: 'Margin trading',
        a_2: 'Spot trading',
        a_3: 'All of the above'
      },
      q_19: {
        q: 'What kind of digital asset trading center that maintains customer assets?',
        a_1: 'Centralized exchange',
        a_2: 'Decentralized Exchange',
        a_3: 'All of the above'
      },
      q_20: {
        q: 'What kind of digital asset trading center will users keep their digital assets by themselves?',
        a_1: 'Centralized exchange',
        a_2: 'Decentralized Exchange',
        a_3: 'All of the above'
      }
    },
    market_manipulation: {
      q_1: {
        q: 'Which is to create an order to trade without real trading to let other investors understand that the digital asset price is increasing?',
        a_1: 'Setting fraudulent purchase orders or offers.',
        a_2: 'Trading among themselves.',
        a_3: 'Hauling and pushing.'
      },
      q_2: {
        q: 'Which is a purchase and sale order that is a pairing transaction between individuals or between groups of related parties?',
        a_1: 'Setting fraudulent purchase orders or offers.',
        a_2: 'Trading among themselves.',
        a_3: 'Hauling and pushing.'
      },
      q_3: {
        q: 'Which is that a lot of people or groups buy a digital asset and create false news that causes the value of that digital asset to rise and then sell all of their digital assets?',
        a_1: 'Setting fraudulent purchase orders or offers.',
        a_2: 'Trading among themselves.',
        a_3: 'Hauling and pushing.'
      },
      q_4: {
        q: 'What is the meaning of trading among themselves?',
        a_1: 'Creating a purchase and sale order without real trading to let other investors understand that the digital asset price is higher.',
        a_2: 'Creating a purchase and sale orders that are a pairing transaction between individuals or between related parties.',
        a_3: 'When a lot of people or groups buy a digital asset and create false news that causes the value of that digital asset to rise and then sell all of their digital assets.'
      },
      q_5: {
        q: 'What is the meaning of setting fraudulent purchase orders or offers?',
        a_1: 'Creating a purchase and sale order without real trading to let other investors understand that the digital asset price is higher.',
        a_2: 'Creating a purchase and sale orders that are a pairing transaction between individuals or between related parties. ',
        a_3: 'When a lot of people or groups buy a digital asset and create false news that causes the value of that digital asset to rise and then sell all of their digital assets.'
      },
      q_6: {
        q: 'What is the meaning of hauling and pushing?',
        a_1: 'Creating a purchase and sale order without real trading to let other investors understand that the digital asset price is higher',
        a_2: 'Creating a purchase and sale orders that are a pairing transaction between individuals or between related parties.',
        a_3: 'When a lot of people or groups buy a digital asset and create false news that causes the value of that digital asset to rise and then sell all of their digital assets.'
      },
      q_7: {
        q: 'Which is a way that people persuade or convince an investor to buy and sell a digital asset to create a fee and receive a share of the fee?',
        a_1: 'Creating trading volumes for fees.',
        a_2: 'Use of internal information.',
        a_3: 'Spreading rumors or making false statements.'
      },
      q_8: {
        q: 'Which is that a person who is in a position to be able to know the significant facts of a digital asset and use that information to benefit him or her in trading digital assets?',
        a_1: 'Creating trading volumes for fees.',
        a_2: 'Use of internal information.',
        a_3: 'Spreading rumors or making false statements.'
      },
      q_9: {
        q: 'Which is to release rumors intentionally to mislead people about the facts of digital assets or to understand which digital assets will increase or decrease?',
        a_1: 'Creating trading volumes for fees.',
        a_2: 'Use of internal information.',
        a_3: 'Making false statements.'
      },
      q_10: {
        q: 'What is the meaning of creating a trading volume for a fee?',
        a_1: 'A way that people persuade or convince an investor to buy and sell a digital asset to create a fee and receive a share of the fee.',
        a_2: 'A person who is in a position to be able to know the significant facts of a digital asset and use that information to benefit him or her in trading digital assets.',
        a_3: 'Release rumors intentionally to mislead people about the facts of digital assets or to understand which digital assets will increase or decrease.'
      },
      q_11: {
        q: 'What is the meaning of using private information?',
        a_1: 'A way that people persuade or convince an investor to buy and sell a digital asset to create a fee and receive a share of the fee.',
        a_2: 'A person who is in a position to be able to know the significant facts of a digital asset and use that information to benefit him or her in trading digital assets.',
        a_3: 'Release rumors intentionally to mislead people about the facts of digital assets or to understand which digital assets will increase or decrease.'
      },
      q_12: {
        q: 'What is the meaning of making false statements?',
        a_1: 'A way that people persuade or convince an investor to buy and sell a digital asset to create a fee and receive a share of the fee.',
        a_2: 'A person who is in a position to be able to know the significant facts of a digital asset and use that information to benefit him or her in trading digital assets.',
        a_3: 'Release rumors intentionally to mislead people about the facts of digital assets or to understand which digital assets will increase or decrease.'
      },
      q_13: {
        q: 'Which option describes the act of controlling the purchase price by buying a large number of digital assets in order to stock up and causing the digital assets to be out of stock and drives up the price?',
        a_1: 'Centralization of purchasing power.',
        a_2: 'Controlling the number of digital assets in the market to manipulate price.',
        a_3: 'Using customer trading information in the form of taking advantage of customers.'
      },
      q_14: {
        q: 'Which is that a digital asset broker or a digital asset trading center that knows customer trading information and then goes ahead to buy and sell digital assets before the client has a chance?',
        a_1: 'Centralization of purchasing power.',
        a_2: 'Controlling the number of digital assets in the market to manipulate price.',
        a_3: 'Using customer trading information in the form of taking advantage of customers.'
      },
      q_15: {
        q: 'What is the meaning of controlling the number of digital assets in the market to manipulate price?',
        a_1: 'Authorizing any person to trade digital assets on their behalf, whereby that person has a vested interest in profits and losses, allowing him or her to control a large amount of trading power.',
        a_2: 'Controlling the purchase price by buying a large number of digital assets in order to stock up and causing digital assets to be out of stock and then determine the price of those digital assets at a high price.',
        a_3: 'A digital asset broker or a digital asset trading center that knows customer trading information and then goes ahead to buy and sell digital assets before the client have a chance.'
      },
      q_16: {
        q: 'What is the meaning of using customer trading information in the form of taking advantage of customers?',
        a_1: 'Authorizing any person to trade digital assets on their behalf, whereby that person has a vested interest in profits and losses, allowing him or her to control a large amount of trading power.',
        a_2: 'Controlling the purchase price by buying a large number of digital assets in order to stock up and causing digital assets to be out of stock and then determine the price of those digital assets at a high price.',
        a_3: 'A digital asset broker or a digital asset trading center that knows customer trading information and then goes ahead to buy and sell digital assets before the client have a chance.'
      },
      q_17: {
        q: 'What is to trick investors to believe that digital asset prices will rise in the hope of being able to sell digital assets at a high price by placing a high-price purchase order for other investors to set up following this order and then cancel the order to make an offer to sell their digital assets to the investors who are tricked?',
        a_1: 'Inflating the price',
        a_2: 'Trading using credit rights',
        a_3: 'Underestimating the price to be too low'
      },
      q_18: {
        q: 'Which option describes the act of creating false news and propaganda to reduce investor confidence in a particular type of digital assets that causes investors to sell such digital assets?',
        a_1: 'Inflating the price',
        a_2: 'Trading using credit rights',
        a_3: 'Underestimating the price to be too low'
      },
      q_19: {
        q: 'What is the meaning of inflating the price?',
        a_1: 'Tricking investors into believing that digital asset prices will rise in the hope of being able to sell digital assets at a high price by placing a high-price purchase order for other investors to set up following this order and then cancel the order to make an offer to sell their digital assets to the investors who are tricked.',
        a_2: 'The trading that a trader can sell certain assets without actually delivering the asset.',
        a_3: 'Creating false news and propaganda to reduce investor confidence in a particular type of digital assets that causes investors to sell those digital assets.'
      },
      q_20: {
        q: 'Which is to enter commands by a computer program in bulk and then cancel fast so that others understand whether the price of digital assets will rise or fall?',
        a_1: 'Setting fraudulent purchase orders or offers.',
        a_2: 'Trading in large numbers.',
        a_3: 'Enter false order to spy.'
      }
    }
  },
  knowledge_test_v2: {
    cryptocurrency: {
      q_1: {
        q: 'What is a Cryptocurrency?',
        a_1: 'An electronic data unit was created to serve as a intermediary of exchange, services, digital assets or other rights by encrypted on a system called “Blockchain”.',
        a_2: 'A type of stock issued by the government.',
        a_3: 'Gold price-bound funds'
      },
      q_2: {
        q: 'What are the features of Stablecoins?',
        a_1: 'It is a cryptocurrency that pegs its value to stable assets.',
        a_2: 'Volatility increases several times in a short time.',
        a_3: 'There is a harsh decrease in value over time.'
      },
      q_3: {
        q: 'What is the difference between cryptocurrency and gold?',
        a_1: 'Cryptocurrency can be traded and accumulated for speculation.',
        a_2: 'Cryptocurrency is encrypted and store data with Blockchain technology',
        a_3: 'Gold has a trading price that varies according to market conditions.',
        a_4: 'All correct'
      },
      q_4: {
        q: 'What is the difference between cryptocurrency and traditional Assets?',
        a_1: 'Cryptocurrency use Blockchain technology',
        a_2: 'Can trade through intermediaries such as Exchange, Broker or Dealer',
        a_3: 'Can be used as an intermediaries for exchanging under Thai law',
        a_4: 'All correct'
      },
      q_5: {
        q: 'Which of the following is correct about cryptocurrency and digital tokens?',
        a_1: 'Cryptocurrencies and digital tokens be or be not an electronic data units.',
        a_2: 'Cryptocurrencies were created to serve as a medium for trading goods or services. Whereas digital tokens are created to assign holders the right to acquire goods or services or any other rights',
        a_3: 'Securities (eg stocks, bonds, etc.) built on the Blockchain not considered securities. Rather, it could be a cryptocurrency digital asset or a digital token',
        a_4: 'Stablecoins are not considered as a cryptocurrencies or digital tokens.'
      },
      q_6: {
        q: 'Which of the following is incorrect?',
        a_1: 'Cryptocurrencies and digital tokens have the same meaning.',
        a_2: 'A digital token is an electronic data unit created on the system for the purpose of the right to participate in any project or activity. or assigning the right to acquire a specific product or service',
        a_3: 'Cryptocurrency is an electronic data unit created with the intention of being used as a medium for the exchange of goods or services',
        a_4: 'Nothing is correct'
      },
      q_7: {
        q: 'Which of the following is not the meaning of Stablecoin?',
        a_1: 'Cryptocurrency based on the value of another asset, such as gold or oil.',
        a_2: 'Cryptocurrency that are often bought for speculation',
        a_3: 'Cryptocurrency with less volatility than other types of cryptocurrency.',
        a_4: 'Cryptocurrency that retain their value with different currencies'
      },
      q_8: {
        q: 'What are the features of cryptocurrency?',
        a_1: 'An electronic data unit created on an electronic system or network.',
        a_2: 'It is intended to be used as a medium for exchanging',
        a_3: 'There is no guarantee that the debt can be legally used.',
        a_4: 'All correct'
      },
      q_9: {
        q: 'Which of the following is incorrect about Stablecoin?',
        a_1: 'It is classified as one of the types of the cryptocurrencies under Thai law.',
        a_2: 'There is a mechanism to maintain value against other assets',
        a_3: 'The price will not fluctuate according to demand of the markets',
        a_4: 'Bitcoin and Ethereum are stable coins'
      },
      q_10: {
        q: 'Which of the following is incorrect about the difference between Cryptocurrency, Digital tokens and assets',
        a_1: 'Digital asset transactions can be done without going through a central authority. It can be performed and verified by a protocol confirmation across the entirely network',
        a_2: 'Digital assets can trade for 24 hours a day and it is delivered in real time.',
        a_3: 'Most digital asset do not returns the dividends. like the original asset.',
        a_4: 'The price of digital assets that will not change according to market demand like the original asset.'
      },
      q_11: {
        q: 'What are not the features of cryptocurrency?',
        a_1: 'Cryptocurrency is money that every central bank in the world guarantees that it can be legally used to pay debts or financial obligations',
        a_2: 'Cryptocurrency was created by Blockchain technology, supporting exchanges between users.',
        a_3: 'Cryptocurrency can not be used as a medium for exchanging goods and services under Thai law.',
        a_4: 'Cryptocurrency can trade in Exchange, Broker or Dealer.'
      },
      q_12: {
        q: 'Which of the following is meaning of stablecoin?',
        a_1: 'There is a system to protect user identity.',
        a_2: 'Determine the right to join any project',
        a_3: 'The valued is relatively stable. The price moves by asset collateralized',
        a_4: 'Coin that are created for fun, meme or trendy'
      },
      q_13: {
        q: 'Which of the following is correct?',
        a_1: 'Fiat currencies such as the US Dollar can be used to pay debts or financial obligations',
        a_2: 'Digital tokens cannot be trade for limited. ',
        a_3: 'Digital tokens cannot be used for fundraising.',
        a_4: 'Cryptocurrency can be used to pay for goods and services like a fait currency'
      },
      q_14: {
        q: 'Which of the following is incorrect about the features of cryptocurrency?',
        a_1: 'An electronic unit created on an electronic network to serve as a medium for the exchange of goods or services.',
        a_2: 'An electronic unit created on an electronic network to determine rights.',
        a_3: 'An electronic units created on electronic networks to express ownership rights in goods or services.',
        a_4: 'An electronic unit created on an electronic network for identity verification.'
      },
      q_15: {
        q: 'Which of the following is meaning of cryptocurrency?',
        a_1: 'Cryptocurrency is classified as a highly volatile asset compared to other types of investments',
        a_2: '“Bitcoin” is a cryptocurrency',
        a_3: 'Cryptocurrency is a part of Blockchain technology',
        a_4: 'Currently, cryptocurrency can be used to settle the legal debts'
      },
      q_16: {
        q: 'What is the legal status of cryptocurrency in Thailand?',
        a_1: 'is illegal.',
        a_2: 'is a digital assets.',
        a_3: 'is a type of currency.',
        a_4: 'is an electronic data.'
      },
      q_17: {
        q: 'Which statement below is not correct?',
        a_1: 'Cryptocurrency has the definition same as token',
        a_2: 'Tokens are digital units created with a purpose defined by the issuer and will differ in function and utility',
        a_3: 'Cryptocurrency is a type of digital assets that uses cryptography for security and has been designed as a means of payment similar to a currency',
        a_4: 'None of the above'
      },
      q_18: {
        q: 'Which coin is not a stablecoin?',
        a_1: 'USDT',
        a_2: 'DAI',
        a_3: 'ETH',
        a_4: 'TUSD'
      }
    },
    blockchain: {
      q_1: {
        q: 'Which of the following make blockchain safe?',
        a_1: 'Transparency and easy to verify',
        a_2: 'Data is encrypted. ',
        a_3: 'Difficult to edit data',
        a_4: 'All correct'
      },
      q_2: {
        q: 'Which of the following is correct about blockchain?',
        a_1: 'Blockchain is irrelevant with cryptocurrencies.',
        a_2: 'Blockchain is a centralized system',
        a_3: 'Blockchain is a technology that stores cryptocurrency transaction data. '
      },
      q_3: {
        q: 'What is a "Proof-of-Stake Consensus"?',
        a_1: 'A consensus mechanism to validate new transactions by providing a "validator" holding a predetermined amount of digital assets. And once the transaction is reviewed, the reviewer earn a reward.',
        a_2: 'A consensus mechanism where miners solve cryptographic puzzles to validate new transactions and earn a reward',
        a_3: 'A consensus mechanism for random a validators take action manually in order to validate new transactions and earn a reward',
        a_4: 'None of the above'
      },
      q_4: {
        q: 'What is a Proof-of-Work Consensus?',
        a_1: 'A consensus mechanism in which “validators” lock up set amounts of cryptocurrency or digital tokens in order to validate new transactions and earn a reward',
        a_2: 'A consensus mechanism that validates transactions by having a "miner" solve cryptographic puzzle and once the transaction is verified, the reviewer earn a reward.',
        a_3: 'A consensus mechanism for random a validators take action manually in order to validate new transactions and earn a reward',
        a_4: 'None of the above'
      },
      q_5: {
        q: 'What will happen if you send your coins to the wrong address?',
        a_1: 'Your coins will not be sent since it is an incorrect address and will remain in your account',
        a_2: 'Your coins will be sent to the incorrect address and may be impossible to retrieve',
        a_3: 'You coins will still be sent to the correct address regardless',
        a_4: 'None of the above'
      },
      q_6: {
        q: 'What is a Blockchain technology?',
        a_1: 'Blockchain technology use for storing data in each period, linked like a chain and all data will be copied and distributed  to all users of the system',
        a_2: 'Technology that does not require middleman but let all the participater in the Blockchain network can verify each other cause a diffucult or impossible to edit data on Blockchain',
        a_3: 'Technology that can improving a smart contract for processing the condition in the form of If-Then can make a transaction successfully',
        a_4: 'All correct'
      },
      q_7: {
        q: 'which of the following is not a risk of Blockchain technology?',
        a_1: 'The connecting between a basic construction and Blockchain network that does not stable enough can be effected all the data processing on the system',
        a_2: 'The change of data is the cause of no transparency in the system',
        a_3: 'The change of technology is the cause of cyber threats increasing',
        a_4: 'The change of legal supervision'
      },
      q_8: {
        q: 'What is a meaning of Node?',
        a_1: 'Blockchain',
        a_2: 'A type of cryptocurrency',
        a_3: 'Computers connected to the Blockchain network',
        a_4: 'Types of digital asset wallets'
      },
      q_9: {
        q: 'What are not the features of Blockchain?',
        a_1: 'Borderless',
        a_2: 'Customizability',
        a_3: 'Ownership',
        a_4: 'Immutable'
      },
      q_10: {
        q: 'What are the basic of Blockchain technology which is irrelevant to the creation and trading a Cryptocurrency process.',
        a_1: 'Data Integrity',
        a_2: 'Data Transparency',
        a_3: 'Transaction tracsability',
        a_4: 'Ability of identification'
      },
      q_11: {
        q: 'Which of the following is not Blockchain technology?',
        a_1: 'Able to do a Peer-to-Peer transactions',
        a_2: 'Decentralized processing ',
        a_3: 'Transactions recorded on the Blockchain can be edited. ',
        a_4: 'Blockchain databases store in blocks that are linked like a chain.'
      },
      q_12: {
        q: 'Which of the following is Blockchain technology?',
        a_1: 'Decentralized processing technology',
        a_2: 'Recorded data in the Blockchain system is difficult to modify',
        a_3: 'Information is reliable and verifiable',
        a_4: 'All correct'
      },
      q_13: {
        q: 'Which of the following is not a collecting data in Blockchain?',
        a_1: 'Block structure design',
        a_2: 'Collect the data in many locations',
        a_3: 'Centralized data collection'
      },
      q_14: {
        q: 'Blockchain technology is secure due to its invariability from three underlying aspects; decentralization, cryptography, and consensus. Is this statement true or false?',
        a_1: 'True',
        a_2: 'False'
      },
      q_15: {
        q: 'Investors must be vigilant and not fall for A cyber attack. Protecting and keeping one’s private key safe is very important. Anyone that possesses your private key can access your funds. What should you do with your private key?',
        a_1: 'I can leave my private key lying around for everyone to see.',
        a_2: 'I should share my private key with my friends.',
        a_3: 'I should not reveal my private key to anyone.',
        a_4: 'I should make a digital copy of my private key and store it online.'
      },
      q_16: {
        q: 'What are the strengths of Blockchain?',
        a_1: 'Increase the reliability of data storage',
        a_2: 'Information cannot be changed or modified.',
        a_3: 'Don\'t use intermediaries to store and verify information.',
        a_4: 'All correct'
      },
      q_17: {
        q: 'What is Blockchain splits?',
        a_1: 'A split',
        a_2: 'A division',
        a_3: 'A sidechain',
        a_4: 'A fork'
      },
      q_18: {
        q: 'What is Public blockchain?',
        a_1: 'A digital ledger where data is stored on a network of independent computers',
        a_2: 'A digital ledger that is created and managed by a company but is made available to the public',
        a_3: 'A government-facilitated platform for currency exchange',
        a_4: 'A type of computer created for bitcoin mining'
      },
      q_19: {
        q: 'What is/are properties of Blockchain?',
        a_1: 'Decentralized',
        a_2: 'Immutable',
        a_3: 'Consensus',
        a_4: 'All of the above'
      },
      q_20: {
        q: 'Which statement is correct regarding smart contract?',
        a_1: 'NFT technology does not require smart contract',
        a_2: 'A program that stores information in Blockchain and automatically execute based on pre-determined conditions',
        a_3: 'Smart Contract can change transaction history',
        a_4: 'All of the above'
      }
    },
    cryptocurrency_wallet: {
      q_1: {
        q: 'What will happen if you send a Digital asset to the wrong wallet address?',
        a_1: 'The digital asset will be reversed back to your wallet.',
        a_2: 'The digital asset will be lost permanently.'
      },
      q_2: {
        q: 'What might happen when entering the address of the recipient wrong.',
        a_1: 'Coins will be returned to the last account because the recipient\'s address is incorrect.',
        a_2: 'Coins will be transferred to the destination but not the correct account.',
        a_3: 'Nothing happened, the coin was transferred to the destination correctly.',
        a_4: 'A and B are correct.'
      },
      q_3: {
        q: 'What are the risks that may arise from using the service through an exchange platform?',
        a_1: 'The service provider (Cryptocurrency Exchange) will keep the private key.',
        a_2: 'The platform has an error causing it can not trade',
        a_3: 'The cryptocurrencies in the account were lost due to  Exchange was attacked by hacker',
        a_4: 'All correct'
      },
      q_4: {
        q: 'Which of the following is correct about digital asset wallet',
        a_1: 'Store the cryptocurrency before they are used. ',
        a_2: 'Calculate the price of cryptocurrency.',
        a_3: 'It should not be used because of its low security.'
      },
      q_5: {
        q: 'How can you tranfer your cryptocurrency completely?',
        a_1: 'Verify the recipient wallet address every time before tranfer.',
        a_2: 'Study and understand the transfer process or ask the staff for advice',
        a_3: 'All correct'
      },
      q_6: {
        q: 'Where can investors store cryptocurrency and digital tokens?',
        a_1: 'Bank account',
        a_2: 'Hot wallet',
        a_3: 'Cold wallet',
        a_4: 'Correct both B and C '
      },
      q_7: {
        q: 'Which of the following is correct about hot wallet and cold wallet?',
        a_1: 'Digital asset operators in Thailand must store most of their customer\'s cryptocurrency in a cold wallet or store them with digital asset custody.',
        a_2: 'Cold Wallet is more secure from hacker than hot wallet.',
        a_3: 'If the digital wallet\'s private key is accessed or disclosed to publiC. The investor should immediately move cryptocurrency out of digital wallet to be stored elsewhere.',
        a_4: 'Investors should store their private keys with Cloud providers.'
      },
      q_8: {
        q: 'How to keep your digital asset wallet?',
        a_1: 'Store the cryptocurrency for spent in hot wallet and store the remaining cryptocurrency in cold wallet.',
        a_2: 'Must have a reserved wallet if the prior wallet was damaged, lost or stolen.',
        a_3: 'Refrain from connecting to public WiFi.',
        a_4: 'All correct.'
      },
      q_9: {
        q: 'What are the advantages of depositing cryptocurrency in custodial wallet?',
        a_1: 'Service providers will have a storage system. So don\'t worry about that.',
        a_2: 'Customers make transactions easily.',
        a_3: 'All correct.'
      },
      q_10: {
        q: 'Which of the following is correct about types and usability of digital assets?',
        a_1: 'Hardware wallet is a custodial wallet device. The private key is stored on the device offline, making it highly secure from cyber attack',
        a_2: 'Paper wallet is a non-custodial wallet. Users creating wallet on the website and keep private key by writing down on a note or paper but risky from faded ink or lost',
        a_3: 'Desktop/ Mobile wallet is a non-cutodial wallet by installing wallet program into computer or smartphone and store the encrypted private key in it. Security depends on the level of security of the device itself',
        a_4: 'B and C are correct'
      },
      q_11: {
        q: 'Which of the following is correct about depositing Cryptocurrency in custodial wallet?',
        a_1: 'There is a segregation of customer assets from the operator\'s assets.',
        a_2: 'Customers can send orders to transfer the cryptocurrenc out of the operator\'s wallet by themselves.',
        a_3: 'Store most of customer\'s cryptocurrency with a crytocurrency custodian.',
        a_4: 'All correct.'
      },
      q_12: {
        q: 'What are the benefits of a Digital wallet?',
        a_1: 'used to store banknotes.',
        a_2: 'used to store financial instruments.',
        a_3: 'used to store digital assets.',
        a_4: 'used to store gold bars.'
      },
      q_13: {
        q: 'Which of the following is not a Digital wallet which used to store Cryptocurrency?',
        a_1: 'Hot Wallet',
        a_2: 'Cold Wallet / Storage',
        a_3: 'Hardware Wallet',
        a_4: 'Bank account'
      },
      q_14: {
        q: 'How do you recover the pivate key if you lost your Hardware wallet?',
        a_1: 'Notify the SEC.',
        a_2: 'Use the reserved seed.',
        a_3: 'Cannot be recovered.'
      },
      q_15: {
        q: 'How to verify your transactions?',
        a_1: 'Address',
        a_2: 'Transaction ID',
        a_3: 'All correct'
      },
      q_16: {
        q: 'Which of the following is a type of stablecoin?',
        a_1: 'Fiat-Backed stablecoin',
        a_2: 'Crypto-Backed stablecoin',
        a_3: 'Algorithmic stablecoin',
        a_4: 'All currect'
      },
      q_17: {
        q: 'Cryptocurrency transaction status can be checked using transaction ID (TxID.  or wallet address. Is this statement TRUE or FALSE?',
        a_1: 'TRUE',
        a_2: 'FALSE'
      },
      q_18: {
        q: 'You purchase a hardware wallet to store Bitcoin directly from the manufacturer, set it up, and write the 12 recovery words down on a piece of paper. You send one Bitcoin to the wallet address and confirm it has arrived. Later the hardware wallet is destroyed, and you have lost the recovery words. How can the Bitcoin be recovered?',
        a_1: 'The Bitcoin cannot be recovered.',
        a_2: 'The Bitcoin can be recovered by the hardware wallet manufacturer.',
        a_3: 'The Bitcoin can be recovered by the exchange.',
        a_4: 'The Bitcoin can be recovered by the SEC.'
      },
      q_19: {
        q: 'What are the precautions for beginners about Digital wallet?',
        a_1: 'Fake crypto wallet',
        a_2: 'Do not take a picture of the Seed Phrase, stored on your PC, smart phone, etc.',
        a_3: 'Carefully verify the destination of every transfer.',
        a_4: 'All correct.'
      },
      q_20: {
        q: 'What should you not to do if hold on Cryptocurrency?',
        a_1: 'Manually store cryptocurrency in your Hardware Wallet.',
        a_2: 'Approve your friends to keep cryptocurrency. Because friends are more knowledgeable.',
        a_3: 'Keep cryptocurrency with exchange.',
        a_4: 'Manage the risk of storing cryptocurrency in both hardware wallets and exchanges according to investment.'
      },
      q_21: {
        q: 'What is Cold storage?',
        a_1: 'A desktop wallet',
        a_2: 'Document storage outside of digital devices',
        a_3: 'A private key not connected to the Internet',
        a_4: 'All of the above'
      },
      q_22: {
        q: 'What is a custodial wallet?',
        a_1: 'Digital wallet service which store customer\'s cryptocurrency. The custodial wallet provider will keep the private key.',
        a_2: 'Digital wallet that the provider developed a program without keeping the private key.',
        a_3: 'Name of the company that developed the wallet.',
        a_4: 'All currect'
      },
      q_23: {
        q: 'Which statement(s) is not correct regarding Private Key storage and safe-keeping of digital assets?',
        a_1: 'Keep Private Key in the cloud and an additional copy in your computer',
        a_2: 'Keep private key in paper format and store in a safe',
        a_3: 'Use a Hardware Wallet and store in a safe',
        a_4: 'None of the above'
      },
      q_24: {
        q: 'What is the importance of a private key?',
        a_1: 'Perform as a password and can be used to access funds in digital wallet',
        a_2: 'Perform as an email address and can be sent to others',
        a_3: 'If the Private Key is lost, a new one can easily be created',
        a_4: 'All of the above'
      }
    },
    investment: {
      q_1: {
        q: 'Which of the following is correct about cryptocurrency market?',
        a_1: 'The cryptocurrency market is more volatile than the stock market.',
        a_2: 'The cryptocurrency market is less volatile than the stock market.',
        a_3: 'The cryptocurrency market is not volatile.'
      },
      q_2: {
        q: 'Which of the following affected the price of cryptocurrency?',
        a_1: 'News related to the cryptocurrency',
        a_2: 'Situations affecting world market conditions',
        a_3: 'All currect '
      },
      q_3: {
        q: 'Which of the following is not a factor in the fundamental valuation of cryptocurrency?',
        a_1: 'The quantity of coins is limited or can be created more.',
        a_2: 'Smart Contracts used with cryptocurrency should be reviewed by reliable auditors.',
        a_3: 'Utilization or rights of cryptocurrency',
        a_4: 'Price volatility'
      },
      q_4: {
        q: 'Which the investment  is acceptable risk?',
        a_1: 'Can take a 10% loss of total investment : invest 10% in cryptocurrencies',
        a_2: 'Can take a 50% loss of the total investment : invest 50% in cryptocurrencies',
        a_3: 'Can take a 100% Loss of Total Investment : invest 100% in cryptocurrencies',
        a_4: 'All  correct'
      },
      q_5: {
        q: 'What are the characteristics of the cryptocurrency market?',
        a_1: 'It is a highly volatile market.',
        a_2: 'It is  illegal in some countries.',
        a_3: 'It is a market that can be traded 24 hours a day.',
        a_4: 'All correct.'
      },
      q_6: {
        q: 'Which of the following is correct about the cryptocurrency market affecting investments?',
        a_1: 'Market trends will drive all industries to digitize (Digitalization)',
        a_2: 'Although the cryptocurrency market is highly volatile. But there are new investors is increasing steadily over the years',
        a_3: 'Social media is an important tool to analyze the market for novice cryptocurrency investors.',
        a_4: 'All correct'
      },
      q_7: {
        q: 'Which of the following is incorrect about cryptocurrency price volatility?',
        a_1: 'The cryptocurrency market is less volatile than the stock market.',
        a_2: 'News and celebrity influence cryptocurrency price volatility',
        a_3: 'Economic stability affects cryptocurrency price volatility',
        a_4: 'Price volatility affects the credibility of cryptocurrencies. If there is a low level of credibility The risk will be high. And it affects the decision to invest in cryptocurrencies.'
      },
      q_8: {
        q: 'Which of the following is not a risk management?',
        a_1: 'Invest with acceptable risks',
        a_2: 'Always monitoring your cryptocurrency trading account.',
        a_3: 'Study and understamding the informations before making an investment decision.',
        a_4: 'Invest with focus on cryprocurrency investments solely'
      },
      q_9: {
        q: 'Which of the following is incorrect?',
        a_1: 'Be careful and check the validity in every digital asset transfer to prevent loss',
        a_2: 'Cryptocurrencies are relatively stable in value, so investors with low risk tolerance should have their stake in cryptocurrencies more than any other assets',
        a_3: 'Prices and trading volumes of cryptocurrencies depends on factors such as demand and supply at the moment, news from platform developers or from influencers through different social media',
        a_4: 'Investors should research, make a diversified risks and have investment strategies to suit their own risk assessment results.'
      },
      q_10: {
        q: 'Which of the following is most correct about the way to calculate the value of cryptocurrency?',
        a_1: 'Valuate the market value of cryptocurrencies with the value of gold.',
        a_2: 'Valuate in the same way as other currencies based on the volume of money in the system.',
        a_3: 'Valuate the value of cryptocurrencies as goods and products by calculating the cost of production.',
        a_4: 'The most valuation of cryptocurrencies is still new and there is no definite theory to support it.'
      },
      q_11: {
        q: 'Which of the following is correct about cryptocurrency market?',
        a_1: 'Open for trading 24 hours a day',
        a_2: 'The assets traded are in the form of cryptocurrencies and digital tokens.',
        a_3: 'The risks and price volatility of each cryptocurrency/digital token may vary on economics.',
        a_4: 'All correct'
      },
      q_12: {
        q: 'Which statement is not the action(s) to take when investing in cryptocurrency?',
        a_1: 'Invest according to advice from experts',
        a_2: 'Research extensively about the coin before investing',
        a_3: 'Research the white paper of the coin before investing',
        a_4: 'Evaluate your risk tolerance before investing'
      },
      q_13: {
        q: 'Which of the following is correct about the risk investment in cryptocurrency?',
        a_1: 'Low risk and low yields.',
        a_2: 'The trading price is highly volatile. You can lose all your investments in short time.',
        a_3: 'Moderate risk and high yields.',
        a_4: 'Each cryptocurrency has different risks.'
      },
      q_14: {
        q: 'Which of the following is incorrect about estimate the risk if coins or tokens were price abnormally high before trading?',
        a_1: 'Compare the price with other providers before trading',
        a_2: 'Contact the provider to check whether the coin is abnormal or not.',
        a_3: 'Find an opportunity to make a profit immediately.',
        a_4: 'Cancel the order immediately for prevent unwanted  order.'
      },
      q_15: {
        q: 'How much is the asset risk level of cryptocurrency?',
        a_1: 'High risk',
        a_2: 'Medium risk',
        a_3: 'Low risk',
        a_4: 'There is no risk.'
      },
      q_16: {
        q: 'Which of the following is correct about preparing to trade the cryptocurrencies?',
        a_1: 'Invest with acceptable risk.',
        a_2: 'Choose a platform that certified by the government agency.',
        a_3: 'Study the information of each cryptocurrency before trading',
        a_4: 'All correct.'
      },
      q_17: {
        q: 'What are the kind of trading that inexperienced investors should avoid?',
        a_1: 'Margin trading',
        a_2: 'Spot trading',
        a_3: 'Holding',
        a_4: 'All correct'
      },
      q_18: {
        q: 'Which of the following should not be done to invest in cryptocurrency',
        a_1: 'Always research the cryptocurrency information.',
        a_2: 'Diversify risks appropriately and invest with acceptable risk.',
        a_3: 'All-In in a coin',
        a_4: 'All of the above are correct.'
      },
      q_19: {
        q: 'What are the factors may cause of digital asset price down?',
        a_1: 'The popularity and demand for digital assets will increase in the future',
        a_2: 'High Net Worth and Large Fund buy digital assets because they want to diversify their investment portfolios (Asset Aallocation)',
        a_3: 'FED begin a program of quantitative tightening by reducing liquidity from the financial system it will impact on financial markets including digital assets',
        a_4: 'Non of the above are correct'
      },
      q_20: {
        q: 'Which statement is not the action(s) to take when investing in cryptocurrency?',
        a_1: 'Invest according to advice from experts',
        a_2: 'Research extensively about the coin before investing',
        a_3: 'Research the white paper of the coin before investing',
        a_4: 'Evaluate your risk tolerance before investing'
      },
      q_21: {
        q: 'How is the market capitalization of cryptocurrency calculated?',
        a_1: 'Market price * Volume of deposit and withdrawal',
        a_2: 'Market price * Volume of assets',
        a_3: 'Market price * Trading demand',
        a_4: 'All currect'
      }
    }
  },
  knowledge_test_correct_answer: {
    correct_answer: 'Correct answer'
  },
  summary_of_suit_test: {
    title: 'Suitability Test Results',
    user_risk_point: 'Total scores are between <b>{suitabilityTestPoint}</b> to <b>45</b>',
    user_risk_level: {
      low: `<b>Low-risk Investor.</b> This type of investor has a small tolerance for investment risk. You require a certainly low return more than uncertain investment.<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are bank deposits or government bond.</b><br><br>
        <i>“The digital assets market price is fluctuations in a short time. Investors should study and understand the basics of digital asset investments before investing and always follow digital asset news during the investment period.”</i>`,
      medium: `<b>Medium-to-moderate-low-risk Investor.</b> This type of investor has rather small investment risk tolerance. You emphasized on capital protection and aim for regular income generated from investment<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are government bond, corporate bond or funds.</b><br><br>
        <i>“The digital assets market price is fluctuations in a short time. Investors should study and understand the basics of digital asset investments before investing and always follow digital asset news during the investment period.”</i>`,
      hight: `<b>High-risk Investor.</b> This type of investor is able to accept high investment risk, high market volatility and can accept investment loss with an aim for investment value to grow over the long term.<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are a corporate bond or equity funds.</b>`,
      very_hight: `<b>A-very-high-risk Investor.</b> This type of investor is keen for opportunities to generate a high return and is able to accept substantial risk and can accept quite high investment loss.<br><br>
      <b>Investment risk tolerance and a suitable type of financial instrument are a digital assets.</b>`
    },
    backward_btn: 'Go to Exchange',
    invite_knowledge_test: {
      title: 'Would you like to continue a knowledge test?',
      describe: 'You will be able to trade when your information is verified, completed a suitability test and completed a knowledge test.',
      text_btn: 'Go to Knowledge Test'
    },
    rules_detail: `Decentralized digital asset investment is the digital asset exchange which customers are the person who store assets themselves, therefore, clients should be
      advised to study and understand how to maintain digital assets on their own before every investment. In addition, the transfer of digital assets between the wallet is the
      actual transfer, accordingly, requires time in order to confirm the transaction which might affect the exchange rate, consequently, clients are advised to study the price
      slippage setting and confirmation period for each type of digital asset before making investment decisions.`
  },
  summart_of_knowledge_test: {
    title: 'Knowledge Test Results',
    user_risk_point: 'Your knowledge scores from <b>{knowledgeTestPoint}</b> of <b>10</b>.',
    describe: 'You can learn more from the following investment advice document.',
    article_1: 'Blockchain 101',
    article_2: 'Bitcoin 101',
    article_3: 'Etheremm 101',
    article_4: 'The Future of Blockchain',
    article_5: 'What is a Wallet? (Cryptocurrency Basics)',
    article_6: 'Investing 101 (Cryptocurrency Basics)',
    invite_suite_test: {
      title: 'Would you like to continue a suitablitity test?',
      describe: 'You will be able to trade when your information is verified, completed a suitability test and completed a knowledge test.',
      text_btn: 'Go to Suitability Test'
    }
  },
  referral_program: {
    referral_program: 'Referral Program',
    your_referral_link: 'Your Referral Link',
    qr_code: 'QR code Referral :',
    download_qr: 'Download QR Code',
    press_and_hold: 'Press and hold on the QR Code to download',
    share_social: 'Share social network :',
    url_referral: 'URL Referral Link :',
    received: 'Received',
    invite_friends: 'Invite Friends',
    invited: 'Receive {0} KUL ({1} - {2} Invited)',
    invited_up: 'Receive {0} KUL ({2} Invited up)',
    level: 'Level',
    earn_together: 'Earn Crypto Together',
    rules: 'Rules',
    rules_detail: `1. In order for an invited friend to receive KULAP Token, they must register using the corresponding referral link (QR code or referral ID).<br><br>
    2. Inviters will get KULAP token on the conditions that invitee’s accounts connect their social media at least one account.<br><br>
    3. There is no limit to the number of friends a single account can invite.<br><br>
    4. KULAP does not allow any user to self-invite through multiple accounts. Once such activity has been detected, all referrals and invitee’s accounts will be canceled and all referral KULAP token will be taken back.<br><br>
    <b>Effective as of 2019/09/09 0:00 AM (UTC)</b>`,
    detail: 'Details',
    detail_explain: `<b>Referral Program consists of three levels</b><br><br>
    <b>Level 1</b> - Every invite will <b>get 5 KULAP Token</b> each, <b>invite up to 10 accounts</b> you will get level up.<br>
    <b>Level 2</b> - Every invite will <b>get 10 KULAP Token</b> each, <b>invite up to 10 accounts</b> (Total 20 accounts) you will get level up.<br>
    <b>Level 3</b> - From this level every invite will <b>get 15 KULAP Token</b> each.<br><br>

    For example, If you invited friend 35 people and then How many receive KULAP token?<br>
    First 10 people, You received 50 KULAP token.<br>
    And 10 people later, You received 100 KULAP token.<br>
    And 10 people later, You received 150 KULAP token.<br>
    And 5 people later, You received 75 KULAP token.<br>
    Finally, you total received 375 KULAP token.<br><br>

    Important Notice:<br>
    KULAP reserves the right to change the terms and conditions of the referral program at any time.<br>`
  },
  terms_and_conditions: {
    template: termsAndConditionsTemplateEn
  },
  acknowledge_risk: {
    template: acknowledgeTemplateEn
  },
  two_factors: {
    verify_2fa: 'Verify 2FA',
    backup_key: 'Backup key',
    please_save_backup_key: 'Please save the backup key for recovery 2FA authentication when you lost your device.',
    enter_2fa_code: 'Enter 2FA Code'
  },
  request_objective_of_trading: {
    since: 'Your trading volume is over 5,000,000 Baht (or over 165,000 USD). Please fill objective of trading',
    if_user: 'If you ignore or cancel this form, we will verify your transactions',
    fill_objective: 'Objective of trading',
    please_fill_objective: 'Please fill objective of trading',
    please_fill: 'Please fill',
    fill_reason: 'Please fill objective of trading',
    submit: 'Submit'
  },
  trade_history: {
    title: 'Trade History',
    start_date: 'Start date',
    end_data: 'End date',
    from_token: 'From token',
    to_token: 'To token',
    search: 'Search',
    download: 'Download',
    table_column_date: 'Date',
    table_column_from_token: 'From Token',
    table_column_to_token: 'To Token',
    table_column_value: 'Value',
    table_column_transactions: 'Transactions',
    empty_trade: 'Empty trade'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js